import { rootDoc } from "../../../../helpers/dom-selectors.js";
import makeHeader from "../../../global-components/header.js";
import SettingsBtn from "../../../global-components/settings-btn.js";
import InviteForm from "../components/invite-form.js";
import APP_VIEWS from "./event-router.js";
export default function App({ settingsBtn, settingsOverlay, header, logo }) {
    _initAppShell();
    return Object.freeze({
        resize,
        executeEvent
    });
    function _initAppShell() {
        SettingsBtn({ settingsBtn, settingsOverlay }).init();
        makeHeader({ header, logo }).init();
        InviteForm.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        rootDoc.style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = APP_VIEWS.get(action);
        await view.execute();
    }
}
;
